import { requester } from '../utils';

export const fetchAllDeductionInvoices = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-factor-deduction?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch introduced cafes error', err);
        reject(err);
      });
  });
};

export const changeInvoiceDeductionActivity = (id, isActive) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-factor-deduction/active`,
        method: 'PUT',
        data: {
          id,
          isActive
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteDeductionInvoice = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-factor-deduction/${id}`,
        method: 'DELETE',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const insertNewInvoiceDeduction = ({
  title,
  value,
  currency,
  isPercent,
  isActive,
  showOnFactor
}) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-factor-deduction`,
        method: 'POST',
        data: {
          title,
          value,
          currency,
          isPercent,
          isActive,
          showOnFactor
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllDeductionDeletedsInvoices = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-factor-deduction/deleted?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllUserInvoicesById = (userId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/invoice/user/${userId}?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
